export default {
  enteringsubsidies: {
    title: "Entering subsidies and social surcharges"
  }
};
